import React from "react"
import "../styling.css"
import logo from "../assets/rotarylogo.png"
import Button from "react-bootstrap/Button"
import Form from "react-bootstrap/Form"
import { Modal } from "react-bootstrap"
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage"
import { firestore, storage } from "../config/db.jsx"
import emailjs from "@emailjs/browser"
import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore"

function generateUniqueId() {
  const timestamp = new Date().getTime()
  const random = Math.floor(Math.random() * 10000)
  return `${timestamp}-${random}`
}

export default function Landing() {
  const [showModal, setShowModal] = React.useState(false)

  const handleCloseModal = () => setShowModal(false)
  const handleShowModal = () => setShowModal(true)

  const cutoffDate = new Date("2006-01-01")

  const uploadApplication = async (e) => {
    e.preventDefault()
    const submissionsRef = collection(firestore, "submissions")
    let canProceed = checkIfAllCorrect()

    try {
      const q = query(submissionsRef, where("emailAdress", "==", emailAdress))
      const querySnapshot = await getDocs(q)

      if (!querySnapshot.empty) {
        console.log("User exists")
        setErrorMessage("Stypendium zostało złożone na ten email!")
        return
      }

      if (canProceed) {
        if (isFilePicked && fileReady) {
          console.log("File is picked")

          const uniqueId = generateUniqueId()

          const newSubmission = {
            uid: uniqueId,
            name: firstName,
            surname: lastName,
            createdAt: timeNow,
            emailAdress: emailAdress,
            streetName: streetName,
            houseNumber: houseNumber,
            localNumber: localNumber,
            postalCode: postalCode,
            cityName: cityName,
            fileURL: uploadedFile,
            phoneNumber: phoneNumber,
            agreement1: agreement1,
            agreement2: agreement2,
            type: selectedFile.type.startsWith("video")
              ? "video"
              : "powerpoint",
            guardianName: parentName,
            guardianSurname: parentSurname,
            guardianNumber: parentNumber,
            guardianEmail: guardianEmail,
            birthdate: birthdate,
          }

          const docRef = doc(submissionsRef, uniqueId)
          await setDoc(docRef, newSubmission)

          console.log("Submission added successfully with UID:", uniqueId)

          await emailjs.send(
            "service_6ywgajw",
            "template_9bvyfxr",
            {
              firstName: firstName,
              lastName: lastName,
              emailAdress: emailAdress,
              streetName: streetName,
              houseNumber: houseNumber,
              localNumber: localNumber,
              postalCode: postalCode,
              cityName: cityName,
              phoneNumber: phoneNumber,
              parentName: parentName,
              parentSurname: parentSurname,
              parentNumber: parentNumber,
              guardianEmail: guardianEmail,
              birthdate: birthdate,
            },
            "drrev1HJCZZnseA1b",
          )

          handleShowModal()
          resetForm()
        } else {
          alert("Nie dodałeś filmiku, albo filmik nadal się ładuje!")
        }
      }
    } catch (error) {
      console.error("Error during submission: ", error)
      alert("Wystąpił błąd podczas dodawania zgłoszenia.")
    }
  }

  const resetForm = () => {
    setFirstName("")
    setLastName("")
    setConfirmEmailAdress("")
    setPhoneNumber("")
    setStreetName("")
    setHouseNumber("")
    setLocalNumber("")
    setPostalCode("")
    setCityName("")
    setUploadedFile("")
    setParentName("")
    setParentSurname("")
    setParentNumber("")
    setGuardianEmail("")
    setBirthdate(null)

    document.getElementById("formBasicName").value = ""
    document.getElementById("formBasicSurname").value = ""
    document.getElementById("formBasicEmail").value = ""
    document.getElementById("formBasicConfirmEmail").value = ""
    document.getElementById("formBasicPhoneNumber").value = ""
    document.getElementById("formBasicStreet").value = ""
    document.getElementById("formBasicHouseNumber").value = ""
    document.getElementById("formBasicPostalCode").value = ""
    document.getElementById("formBasicCity").value = ""
    document.getElementById("formBasicParentName").value = ""
    document.getElementById("formBasicParentSurname").value = ""
    document.getElementById("formBasicParentNumber").value = ""
  }

  const [firstName, setFirstName] = React.useState("")
  const [lastName, setLastName] = React.useState("")

  const [agreement1, setAgreement1] = React.useState(false)
  const [agreement2, setAgreement2] = React.useState(false)

  const [emailAdress, setEmailAdress] = React.useState("")
  const [confirmEmailAdress, setConfirmEmailAdress] = React.useState("")
  const [phoneNumber, setPhoneNumber] = React.useState("")
  const [streetName, setStreetName] = React.useState("")
  const [houseNumber, setHouseNumber] = React.useState("")
  const [localNumber, setLocalNumber] = React.useState("")
  const [postalCode, setPostalCode] = React.useState("")
  const [cityName, setCityName] = React.useState("")
  const [uploadedFile, setUploadedFile] = React.useState("")
  const [fileReady, setFileReady] = React.useState(true)

  const [adult, setAdult] = React.useState(false)
  const [parentName, setParentName] = React.useState("")
  const [parentSurname, setParentSurname] = React.useState("")
  const [parentNumber, setParentNumber] = React.useState("")
  const [guardianEmail, setGuardianEmail] = React.useState("")
  const [birthdate, setBirthdate] = React.useState(null)

  const [selectedFile, setSelectedFile] = React.useState("")
  const [isFilePicked, setIsFilePicked] = React.useState(false)
  const [progress, setProgress] = React.useState(0)

  const [nameCorrect, setNameCorrect] = React.useState(true)
  const [surnameCorrect, setSurnameCorrect] = React.useState(true)
  const [emailCorrect, setEmailCorrect] = React.useState(true)
  const [confirmCorrect, setConfirmCorrect] = React.useState(true)
  const [phoneNumberCorrect, setPhoneNumberCorrect] = React.useState(true)
  const [streetCorrect, setStreetCorrect] = React.useState(true)
  const [houseNumberCorrect, setHouseNumberCorrect] = React.useState(true)
  const [postalCodeCorrect, setPostalCodeCorrect] = React.useState(true)
  const [cityCorrect, setCityCorrect] = React.useState(true)
  const [parentNameCorrect, setParentNameCorrect] = React.useState(true)
  const [parentSurnameCorrect, setParentSurnameCorrect] = React.useState(true)
  const [parentNumberCorrect, setParentNumberCorrect] = React.useState(true)
  const [birthdateCorrect, setBirthdateCorrect] = React.useState(true)

  const [errorMessage, setErrorMessage] = React.useState("")

  const [buttonDisabled, setButtonDisabled] = React.useState(false)

  const checkIfAllCorrect = () => {
    setErrorMessage("")
    let correct = true
    if (firstName == "") {
      setNameCorrect(false)
      correct = false
    } else {
      setNameCorrect(true)
    }
    if (agreement1 === false) {
      setErrorMessage("Musisz zapoznać się z regulaminem!.")
      correct = false
    } else {
      setNameCorrect(true)
    }
    if (lastName == "") {
      setSurnameCorrect(false)
      correct = false
    } else {
      setSurnameCorrect(true)
    }
    if (emailAdress !== confirmEmailAdress || emailAdress == "") {
      setEmailCorrect(false)
      setConfirmCorrect(false)
      correct = false
    } else {
      setEmailCorrect(true)
      setConfirmCorrect(true)
    }
    if (streetName.length < 3) {
      setStreetCorrect(false)
      correct = false
    } else {
      setStreetCorrect(true)
    }
    if (houseNumber == "") {
      setHouseNumberCorrect(false)
      correct = false
    } else {
      setHouseNumberCorrect(true)
    }
    if (postalCode == "") {
      setPostalCodeCorrect(false)
      correct = false
    } else {
      setPostalCodeCorrect(true)
    }
    if (cityName.length < 3) {
      setCityCorrect(false)
      correct = false
    } else {
      setCityCorrect(true)
    }
    if (phoneNumber.length < 7) {
      setPhoneNumberCorrect(false)
      correct = false
    } else {
      setPhoneNumberCorrect(true)
    }
    if (parentName.length < 2 && adult === false) {
      correct = false
      setParentNameCorrect(false)
    } else {
      setParentNameCorrect(true)
    }
    if (parentSurname.length < 2 && adult === false) {
      correct = false
      setParentSurnameCorrect(false)
    } else {
      setParentSurnameCorrect(true)
    }
    if (parentNumber.length < 7 && adult === false) {
      correct = false
      setParentNumberCorrect(false)
    } else {
      setParentNumberCorrect(true)
    }
    const selectedDateObj = new Date(birthdate)
    if (birthdate === "" || selectedDateObj < cutoffDate) {
      correct = false
      setBirthdateCorrect(false)
      setErrorMessage(
        "Aby uczestniczyć w programie musisz być młodszy niż 18 lat.",
      )
    } else {
      setBirthdateCorrect(true)
    }

    return correct
  }

  const onDownload = () => {
    fetch("regulamin.pdf").then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob)
        let alink = document.createElement("a")
        alink.href = fileURL
        alink.download = "regulamin.pdf"
        alink.click()
      })
    })
  }

  const timeNow = Date.now()

  const changeHandler = (event) => {
    setFileReady(false)
    const file = event.target.files[0]
    if (!file) {
      return
    } else {
      if (event.target.files[0].size > 20971520) {
        alert("Plik jest za duży! Maksymalny rozmiar to 20MB")
      } else {
        setSelectedFile(event.target.files[0])
        setIsFilePicked(true)
        const storageRef = ref(
          storage,
          `files/${event.target.files[0].size}${file.name}`,
        )
        const uploadTask = uploadBytesResumable(storageRef, file)

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
            )
            console.log(progress)
            setProgress(progress)
          },
          (error) => {
            alert(error)
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              setUploadedFile(downloadURL)
              setFileReady(true)
            })
          },
        )
      }
    }
  }

  console.log(agreement1)
  console.log(agreement2)
  return (
    <div className="landing-page">
      <div className="top-bar center">
        <img className="logo" src={logo} alt="Rotary Logo" />
      </div>

      <Form className="center column landing-form">
        <div className="box-container">
          <h3 className="title">Dane osobowe</h3>

          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicName"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Imię"
                isInvalid={!nameCorrect}
                onChange={(e) => {
                  setFirstName(e.target.value)
                  setNameCorrect(true)
                }}
              />
            </Form.Group>

            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicSurname"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Nazwisko"
                isInvalid={!surnameCorrect}
                onChange={(e) => {
                  setLastName(e.target.value)
                  setSurnameCorrect(true)
                }}
              />
            </Form.Group>
          </div>

          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicEmail"
            >
              <Form.Control
                className="input-text-modern"
                type="email"
                placeholder="Email"
                isInvalid={!emailCorrect}
                onChange={(e) => {
                  setEmailAdress(e.target.value)
                  setEmailCorrect(true)
                }}
              />
            </Form.Group>

            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicConfirmEmail"
            >
              <Form.Control
                className="input-text-modern"
                type="email"
                placeholder="Potwierdź Email"
                isInvalid={!confirmCorrect}
                onChange={(e) => {
                  setConfirmEmailAdress(e.target.value)
                  setConfirmCorrect(true)
                }}
              />
            </Form.Group>
          </div>

          <Form.Group
            className="m-1 form-group-modern"
            controlId="formBasicPhoneNumber"
          >
            <Form.Control
              className="input-text-modern"
              type="tel"
              placeholder="Numer telefonu"
              isInvalid={!phoneNumberCorrect}
              onChange={(e) => {
                setPhoneNumber(e.target.value)
                setPhoneNumberCorrect(true)
              }}
            />
          </Form.Group>

          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicStreet"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Ulica"
                isInvalid={!streetCorrect}
                onChange={(e) => {
                  setStreetName(e.target.value)
                  setStreetCorrect(true)
                }}
              />
            </Form.Group>

            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicHouseNumber"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Numer Mieszkania"
                isInvalid={!houseNumberCorrect}
                onChange={(e) => {
                  setHouseNumber(e.target.value)
                  setHouseNumberCorrect(true)
                }}
              />
            </Form.Group>
          </div>

          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicLocalNumber"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Numer Lokalu"
                onChange={(e) => {
                  setLocalNumber(e.target.value)
                }}
              />
            </Form.Group>

            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicPostalCode"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Kod Pocztowy"
                isInvalid={!postalCodeCorrect}
                onChange={(e) => {
                  setPostalCode(e.target.value)
                  setPostalCodeCorrect(true)
                }}
              />
            </Form.Group>
          </div>

          <Form.Group
            className="m-1 form-group-modern"
            controlId="formBasicCity"
          >
            <Form.Control
              className="input-text-modern"
              type="text"
              placeholder="Miasto"
              isInvalid={!cityCorrect}
              onChange={(e) => {
                setCityName(e.target.value)
                setCityCorrect(true)
              }}
            />
          </Form.Group>

          <h3 className="title section-title">Data urodzenia</h3>
          <Form.Group className="m-1 form-group-modern">
            <Form.Control
              type="date"
              className="input-text-modern"
              value={birthdate || ""}
              isInvalid={!birthdateCorrect}
              onChange={(e) => setBirthdate(e.target.value)}
            />
          </Form.Group>

          <h3 className="title section-title">Dane opiekuna</h3>
          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicParentName"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Imię opiekuna prawnego"
                isInvalid={!parentNameCorrect}
                onChange={(e) => {
                  setParentName(e.target.value)
                  setParentNameCorrect(true)
                }}
              />
            </Form.Group>

            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicParentSurname"
            >
              <Form.Control
                className="input-text-modern"
                type="text"
                placeholder="Nazwisko opiekuna prawnego"
                isInvalid={!parentSurnameCorrect}
                onChange={(e) => {
                  setParentSurname(e.target.value)
                  setParentSurnameCorrect(true)
                }}
              />
            </Form.Group>
          </div>

          <div className="form-row">
            <Form.Group
              className="m-1 form-group-modern"
              controlId="formBasicParentNumber"
            >
              <Form.Control
                className="input-text-modern"
                type="tel"
                placeholder="Numer opiekuna prawnego"
                isInvalid={!parentNumberCorrect}
                onChange={(e) => {
                  setParentNumber(e.target.value)
                  setParentNumberCorrect(true)
                }}
              />
            </Form.Group>

            <Form.Group className="m-1 form-group-modern">
              <Form.Control
                className="input-text-modern"
                type="email"
                placeholder="Email opiekuna prawnego"
                onChange={(e) => setGuardianEmail(e.target.value)}
              />
            </Form.Group>
          </div>

          <h3 className="title section-title">Plik Aplikacji</h3>
          <Form.Group
            controlId="formFileMultiple"
            className="m-1 form-group-modern"
          >
            <Form.Control
              className="input-text-modern file-input"
              type="file"
              accept="video/*, application/pdf, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation"
              onChange={(e) => changeHandler(e)}
            />
            {progress > 0 && progress < 100 && (
              <div className="upload-progress">
                <div
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
                <span className="progress-text">{progress}%</span>
              </div>
            )}
          </Form.Group>

          <div className="agreements-section">
            <Form.Group className="m-1 agreement-group">
              <Form.Check
                name="privacy"
                type="checkbox"
                className="custom-checkbox"
                label={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: `Zapoznałem się z regulaminem programu stypendialnego i zasadami przetwarzania danych osobowych zawartymi w <a href="https://stypendiumrotary.com/regulamin.pdf" target="_blank" className="link-modern">REGULAMINIE</a>`,
                    }}
                  />
                }
                onChange={(e) => setAgreement1(!agreement1)}
              />
            </Form.Group>
            <Form.Group className="m-1 agreement-group">
              <Form.Check
                name="privacy"
                type="checkbox"
                className="custom-checkbox"
                label={`Wyrażam zgodę na przetwarzanie moich danych osobowych dla celów otrzymywania newsletter'a od Stowarzyszenia Rotary Club Warszawa Fryderyk Chopin`}
                onChange={(e) => setAgreement2(!agreement2)}
              />
            </Form.Group>
          </div>
        </div>

        {errorMessage && (
          <div className="error-message-modern">
            <p>{errorMessage}</p>
          </div>
        )}

        <Button
          className="submit-button-modern"
          variant="primary"
          onClick={(e) => uploadApplication(e)}
          disabled={buttonDisabled}
        >
          Wyślij aplikację
        </Button>
      </Form>

      <footer className="landing-footer">
        <div className="footer-text">
          W razie pytań technicznych:{" "}
          <a href="mailto:skupantoni920@gmail.com" className="footer-link">
            skupantoni920@gmail.com
          </a>
        </div>
        <div className="footer-text">
          W razie pytań dot. regulaminu:{" "}
          <a href="mailto:scholarship@rotary.org.pl" className="footer-link">
            scholarship@rotary.org.pl
          </a>
        </div>
      </footer>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="success-modal"
      >
        <Modal.Header closeButton className="modal-header-modern">
          <Modal.Title>Aplikacja złożona</Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body-modern">
          <p>
            Twoja aplikacja została złożona! Potwierdzenie zostało wysłane na:{" "}
            <strong>{emailAdress}</strong>
          </p>
        </Modal.Body>
        <Modal.Footer className="modal-footer-modern">
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Zamknij
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
